/**
 * @generated SignedSource<<5f8694238b1247c6efbdcf5edd86e97d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GLOBAL_FILTER_CONTEXT = "PROJECTS" | "PEOPLE" | "TASKS" | "TIME_REGS" | "INVOICES" | "SKILLS" | "LABELS" | "PLACEHOLDERS" | "RESOURCES" | "%future added value";
export type GLOBAL_FILTER_FIELD = "AUDIT_ACTOR" | "AUDIT_ACTOR_SOURCE" | "AUDIT_APPROVAL_TYPE" | "AUDIT_BATCH_ID" | "AUDIT_EVENT_DATE" | "AUDIT_EVENT_TYPE" | "AUDIT_FIELD_NAME" | "AUDIT_FROM_STATUS" | "AUDIT_IS_MATERIAL" | "AUDIT_TIME_TYPE" | "AUDIT_TO_STATUS" | "AUDIT_WORK_DATE" | "COMPANY_TASK_ID" | "NAME" | "STATUS" | "PROJECT_STATUS" | "PROJECT_GROUP_STATUS" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_GROUP_SPRINT" | "DESCRIPTION" | "REMAINING" | "TIME_REGS" | "FORECAST" | "TASK_APPROVED" | "START_DATE" | "START_DATE_PROJECT" | "END_DATE" | "END_DATE_PROJECT" | "START_DATE_TIME_REG" | "PHASE_TIME_REG" | "END_DATE_TIME_REG" | "PROJECT_TIME_REG" | "ROLE_TIME_REG" | "TEAM_TIME_REG" | "DEPARTMENT_TIME_REG" | "INTERNAL_TIME_REG" | "TIME_OFF_TIME_REG" | "BILLABLE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_TASK_TIME_REG" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "PERSON_TIME_REG" | "CLIENT_TIME_REG" | "SPRINT_TIME_REG" | "LABEL_TIME_REG" | "TASK_TIME_REG" | "CREATED_AT" | "WITH_TIME_REG" | "WITH_TASKS" | "TASK" | "TASK_LEVEL" | "UPDATED_AT" | "SET_DONE_AT" | "ASSIGNED" | "ASSIGNED_SELF" | "OWNER" | "FOLLOWER" | "LABELS" | "PROJECT_LABELS" | "ROLE" | "PROJECT" | "PROJECT_PERSON" | "CLIENT" | "PROJECT_STAGE" | "BUG" | "BLOCKED" | "BILLABLE" | "HIGH_PRIORITY" | "STARRED" | "RECENT_TIME" | "RECENT_TASK_ACTIVITY" | "RECENT_ACTIVITY" | "PHASE_CATEGORY" | "SPRINT_CATEGORY" | "DEADLINE" | "OWN_START_DATE" | "OWN_DEADLINE" | "TEAM_MEMBER" | "TEAM" | "PERMISSION_LEVEL" | "CLIENT_GUEST_USERS" | "DEPENDENCIES" | "SUB_TASKS" | "TASK_HIERARCHY" | "DEPARTMENT" | "PERSON" | "NO_CONTACT" | "APPROVAL_STATUS" | "INTERNAL_TIME" | "TIME_OFF" | "PROJECT_FOLLOWER" | "PROJECT_OWNER" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "RATE_CARD" | "CONTACT" | "INVOICED" | "SKILL" | "PRIORITY_LEVEL" | "PROJECT_GROUP" | "PROGRAM" | "FILTER_BY_TIME_REG_SETTINGS" | "BILL_TO" | "BILL_FROM" | "PROJECT_MANUAL_PROGRESS" | "RETAINER_PERIOD" | "PROJECT_WIN_CHANCE" | "CLIENT_CONTACT_CLIENT_ID" | "CLIENT_CONTACT_COMPANY_ID" | "CLIENT_CONTACT_ID" | "CLIENT_CONTACT" | "CLIENT_CONTACT_NAME" | "CLIENT_CONTACT_FIRST_NAME" | "CLIENT_CONTACT_LAST_NAME" | "CLIENT_CONTACT_EMAIL" | "CLIENT_CONTACT_STATUS" | "CLIENT_CONTACT_IS_GUEST_USER" | "PHASE" | "SPRINT" | "DELIVERABLE" | "PARENT" | "PROGRESS" | "ESTIMATE" | "CREATED" | "UPDATED" | "PROJECT_STATUS_RAG" | "PROGRESS_BUCKET" | "WIN_CHANCE_BAND" | "TOTAL_REGISTERED_HOURS" | "BILLABLE_HOURS" | "NON_BILLABLE_HOURS" | "RETAINER_OVER_UNDER" | "RETAINER_PERIOD_START" | "RETAINER_PERIOD_END" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "IS" | "IS_NOT" | "IS_ALL" | "IS_NOT_ALL" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "LESS" | "LESS_OR_EQUAL" | "IN" | "NOT_IN" | "ALL_IN" | "NOT_ALL_IN" | "%future added value";
export type STATUS_CATEGORY = "TODO" | "INPROGRESS" | "DONE" | "%future added value";
export type TaskSearchQueryType = {
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
};
export type GlobalSearchFilterType = {
  field?: GLOBAL_FILTER_FIELD | null;
  operator?: GLOBAL_FILTER_OPERATOR | null;
  value?: ReadonlyArray<string | null> | null;
  context?: GLOBAL_FILTER_CONTEXT | null;
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
  logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null;
};
export type invoiceEntriesList_Query$variables = {
  searchQuery?: TaskSearchQueryType | null;
  startYear: number;
  startMonth: number;
  startDay: number;
  endYear: number;
  endMonth: number;
  endDay: number;
  includeWorkDetail: boolean;
};
export type invoiceEntriesList_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly company: {
      readonly allProjects: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly projectPersons: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly person: {
                    readonly id: string;
                  } | null;
                  readonly role: {
                    readonly id: string;
                    readonly name: string | null;
                  } | null;
                } | null;
              } | null> | null;
            } | null;
            readonly unInvoicedTimeRegistrations: ReadonlyArray<{
              readonly id: string;
              readonly person: {
                readonly id: string;
              } | null;
              readonly project: {
                readonly id: string;
              } | null;
              readonly role: {
                readonly id: string;
                readonly name: string | null;
              } | null;
              readonly task: {
                readonly id: string;
                readonly name: string | null;
                readonly project: {
                  readonly id: string;
                } | null;
                readonly phase: {
                  readonly id: string;
                  readonly name: string | null;
                } | null;
                readonly sprint: {
                  readonly id: string;
                  readonly name: string | null;
                } | null;
                readonly statusColumnV2: {
                  readonly category: STATUS_CATEGORY | null;
                } | null;
              } | null;
              readonly minutesRegistered: number | null;
              readonly billableMinutesRegistered: number | null;
              readonly year: number | null;
              readonly month: number | null;
              readonly day: number | null;
              readonly price: number | null;
              readonly priceBaseCurrency: number | null;
              readonly rate: number | null;
              readonly notes: string | null;
            } | null> | null;
            readonly timeRegistrations?: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                  readonly year: number | null;
                  readonly month: number | null;
                  readonly day: number | null;
                  readonly minutesRegistered: number | null;
                  readonly rate: number | null;
                  readonly notes: string | null;
                  readonly person: {
                    readonly id: string;
                    readonly firstName: string | null;
                    readonly lastName: string | null;
                  } | null;
                  readonly role: {
                    readonly id: string;
                    readonly name: string | null;
                  } | null;
                  readonly project: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly rateCard: {
                      readonly id: string;
                      readonly currency: string | null;
                    } | null;
                  } | null;
                  readonly task: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly project: {
                      readonly id: string;
                      readonly name: string | null;
                      readonly rateCard: {
                        readonly id: string;
                        readonly currency: string | null;
                      } | null;
                    } | null;
                    readonly statusColumnV2: {
                      readonly category: STATUS_CATEGORY | null;
                    } | null;
                    readonly phase: {
                      readonly id: string;
                      readonly name: string | null;
                    } | null;
                    readonly sprint: {
                      readonly id: string;
                      readonly name: string | null;
                    } | null;
                  } | null;
                } | null;
              } | null> | null;
            } | null;
            readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type invoiceEntriesList_Query = {
  variables: invoiceEntriesList_Query$variables;
  response: invoiceEntriesList_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDay"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endMonth"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endYear"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeWorkDetail"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDay"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startMonth"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startYear"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "invoice_entries_list"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"invoice_entries_list\")"
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  },
  {
    "kind": "Variable",
    "name": "searchQuery",
    "variableName": "searchQuery"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v13 = [
  (v11/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = [
  (v11/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v18 = [
  {
    "kind": "Variable",
    "name": "endDay",
    "variableName": "endDay"
  },
  {
    "kind": "Variable",
    "name": "endMonth",
    "variableName": "endMonth"
  },
  {
    "kind": "Variable",
    "name": "endYear",
    "variableName": "endYear"
  },
  {
    "kind": "Variable",
    "name": "startDay",
    "variableName": "startDay"
  },
  {
    "kind": "Variable",
    "name": "startMonth",
    "variableName": "startMonth"
  },
  {
    "kind": "Variable",
    "name": "startYear",
    "variableName": "startYear"
  }
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "PhaseType",
  "kind": "LinkedField",
  "name": "phase",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Sprint",
  "kind": "LinkedField",
  "name": "sprint",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusColumnV2",
  "kind": "LinkedField",
  "name": "statusColumnV2",
  "plural": false,
  "selections": [
    (v22/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesRegistered",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billableMinutesRegistered",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceBaseCurrency",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RateCard",
      "kind": "LinkedField",
      "name": "rateCard",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusColumnV2",
  "kind": "LinkedField",
  "name": "statusColumnV2",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "invoiceEntriesList_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "allProjects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": (v12/*: any*/),
                            "concreteType": "ProjectPersonTypeConnection",
                            "kind": "LinkedField",
                            "name": "projectPersons",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectPersonTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectPerson",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "projectPersons(first:1000000)"
                          },
                          {
                            "alias": null,
                            "args": (v18/*: any*/),
                            "concreteType": "TimeRegType",
                            "kind": "LinkedField",
                            "name": "unInvoicedTimeRegistrations",
                            "plural": true,
                            "selections": [
                              (v11/*: any*/),
                              (v14/*: any*/),
                              (v19/*: any*/),
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "task",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v15/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "condition": "includeWorkDetail",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TimeRegTypeConnection",
                                "kind": "LinkedField",
                                "name": "timeRegistrations",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeRegTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TimeRegType",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v11/*: any*/),
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v28/*: any*/),
                                          (v24/*: any*/),
                                          (v31/*: any*/),
                                          (v32/*: any*/),
                                          (v33/*: any*/),
                                          (v17/*: any*/),
                                          (v34/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Task",
                                            "kind": "LinkedField",
                                            "name": "task",
                                            "plural": false,
                                            "selections": [
                                              (v11/*: any*/),
                                              (v15/*: any*/),
                                              (v34/*: any*/),
                                              (v23/*: any*/),
                                              (v20/*: any*/),
                                              (v21/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "DeprecatedProjectIndicatorJS_project"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "invoiceEntriesList_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "allProjects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": (v12/*: any*/),
                            "concreteType": "ProjectPersonTypeConnection",
                            "kind": "LinkedField",
                            "name": "projectPersons",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectPersonTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectPerson",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v17/*: any*/),
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "projectPersons(first:1000000)"
                          },
                          {
                            "alias": null,
                            "args": (v18/*: any*/),
                            "concreteType": "TimeRegType",
                            "kind": "LinkedField",
                            "name": "unInvoicedTimeRegistrations",
                            "plural": true,
                            "selections": [
                              (v11/*: any*/),
                              (v14/*: any*/),
                              (v19/*: any*/),
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "task",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v15/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "condition": "includeWorkDetail",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TimeRegTypeConnection",
                                "kind": "LinkedField",
                                "name": "timeRegistrations",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeRegTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TimeRegType",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v11/*: any*/),
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v28/*: any*/),
                                          (v24/*: any*/),
                                          (v31/*: any*/),
                                          (v32/*: any*/),
                                          (v33/*: any*/),
                                          (v17/*: any*/),
                                          (v34/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Task",
                                            "kind": "LinkedField",
                                            "name": "task",
                                            "plural": false,
                                            "selections": [
                                              (v11/*: any*/),
                                              (v15/*: any*/),
                                              (v34/*: any*/),
                                              (v35/*: any*/),
                                              (v20/*: any*/),
                                              (v21/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ]
                          },
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "companyProjectId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "customProjectId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectColor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bbb8797ff6a9aec8f6e0873fde1213c0",
    "id": null,
    "metadata": {},
    "name": "invoiceEntriesList_Query",
    "operationKind": "query",
    "text": "query invoiceEntriesList_Query(\n  $searchQuery: TaskSearchQueryType\n  $startYear: Int!\n  $startMonth: Int!\n  $startDay: Int!\n  $endYear: Int!\n  $endMonth: Int!\n  $endDay: Int!\n  $includeWorkDetail: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"invoice_entries_list\")\n    company {\n      allProjects(first: 100000, searchQuery: $searchQuery) {\n        edges {\n          node {\n            id\n            projectPersons(first: 1000000) {\n              edges {\n                node {\n                  person {\n                    id\n                  }\n                  role {\n                    id\n                    name\n                  }\n                  id\n                }\n              }\n            }\n            unInvoicedTimeRegistrations(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay) {\n              id\n              person {\n                id\n              }\n              project {\n                id\n              }\n              role {\n                id\n                name\n              }\n              task {\n                id\n                name\n                project {\n                  id\n                }\n                phase {\n                  id\n                  name\n                }\n                sprint {\n                  id\n                  name\n                }\n                statusColumnV2 {\n                  category\n                  id\n                }\n              }\n              minutesRegistered\n              billableMinutesRegistered\n              year\n              month\n              day\n              price\n              priceBaseCurrency\n              rate\n              notes\n            }\n            timeRegistrations @include(if: $includeWorkDetail) {\n              edges {\n                node {\n                  id\n                  year\n                  month\n                  day\n                  minutesRegistered\n                  rate\n                  notes\n                  person {\n                    id\n                    firstName\n                    lastName\n                  }\n                  role {\n                    id\n                    name\n                  }\n                  project {\n                    id\n                    name\n                    rateCard {\n                      id\n                      currency\n                    }\n                  }\n                  task {\n                    id\n                    name\n                    project {\n                      id\n                      name\n                      rateCard {\n                        id\n                        currency\n                      }\n                    }\n                    statusColumnV2 {\n                      category\n                      id\n                    }\n                    phase {\n                      id\n                      name\n                    }\n                    sprint {\n                      id\n                      name\n                    }\n                  }\n                }\n              }\n            }\n            ...DeprecatedProjectIndicatorJS_project\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n"
  }
};
})();

(node as any).hash = "4bedc28df97c8bfbae906367b30c336f";

export default node;
